import { render } from "./TerminosCondiciones.vue?vue&type=template&id=3d1a8d5f&scoped=true"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js"

import "./TerminosCondiciones.vue?vue&type=style&index=0&id=3d1a8d5f&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1a8d5f"]])

export default __exports__